import StarFilled from 'assets/star-filled.svg?react'
import styled from 'styled-components'

// Images Section (IS) Styled Components

export const ISImagesContainer = styled.div`
  display: flex;
  flex-direction: row;
  height: auto;
  align-self: stretch;
  gap: 0.5rem;
  flex-wrap: wrap;
  padding: 0.5rem;
`

export const ISStyledImage = styled.div`
  position: relative;
  height: 5rem;
  width: 5rem;
  overflow: hidden;
  border-radius: 0.25rem;
  background-color: ${({ theme }) => theme.forecast.defaultButton};
  cursor: pointer;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`

export const ISStarIconContainer = styled.div<{ $active: boolean }>`
  position: absolute;
  top: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  height: var(--Height-control-height, 2.5rem);
  gap: var(--Padding-1, 0.25rem);
  border-radius: 0.25rem;
  opacity: ${({ $active }) => ($active ? 1 : 0)};
  width: 2rem;
  height: 2rem;
  margin: 0.25rem;
  border-radius: 0.5rem;
  background-color: ${({ theme }) => theme.forecast.glassBackground};
  backdrop-filter: blur(2rem);
  box-shadow:
    0rem 0.0625rem 0.125rem 0rem rgba(0, 0, 0, 0.1),
    0rem 0.25rem 0.5rem 0rem rgba(0, 0, 0, 0.1);
  cursor: pointer;

  path {
    fill: ${({ $active, theme }) =>
      $active ? theme.forecast.activeText : 'none'};
    stroke: ${({ $active, theme }) =>
      $active ? theme.forecast.activeText : theme.forecast.defaultText};
  }

  &:hover {
    background-color: ${({ theme }) => theme.forecast.hoverGhostButton};
  }

  &:active {
    background-color: ${({ theme }) => theme.forecast.activeGhostButton};
  }

  ${ISStyledImage}:hover & {
    opacity: 1;
    pointer-events: all;
  }
`

export const ISStarFilledIcon = styled(StarFilled)`
  height: 1rem;
  width: 1rem;
`

export const ISDeleteIconContainer = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  height: var(--Height-control-height, 2.5rem);
  gap: var(--Padding-1, 0.25rem);
  border-radius: 0.25rem;
  opacity: 0;
  width: 2rem;
  height: 2rem;
  margin: 0.25rem;
  border-radius: 0.5rem;
  background-color: ${({ theme }) => theme.forecast.glassBackground};
  backdrop-filter: blur(2rem);
  box-shadow:
    0rem 0.0625rem 0.125rem 0rem rgba(0, 0, 0, 0.1),
    0rem 0.25rem 0.5rem 0rem rgba(0, 0, 0, 0.1);
  cursor: pointer;

  &:hover {
    background-color: ${({ theme }) => theme.forecast.danger};
  }

  &:active {
    background-color: ${({ theme }) => theme.forecast.activeGhostButton};
  }

  ${ISStyledImage}:hover & {
    opacity: 1;
    pointer-events: all;
  }
`

export const ISFullImageModal = styled.div`
  display: flex;
  flex-direction: column;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  justify-content: center;
  align-items: center;
  z-index: 1000;
  padding: 2rem;
  box-sizing: border-box;
`

export const ISImageAndAVContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 75%;
  height: 75%;
`

export const ISImageContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 50%;
  background-color: #1a1a1a;
  padding: 1rem;
  box-sizing: border-box;
`

export const ISImageWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 75%;
  width: 100%;
  overflow: hidden;
  padding: 0.5rem;
`

export const ISFullSizedImage = styled.img`
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
`

export const ISInputsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  background-color: #1a1a1a;
  height: 30%;
  padding: 0.5rem;
`

export const ISHeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  background-color: #1a1a1a;
  height: 20%;
  padding: 0.5rem;
`

export const ISInputRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1rem;
`

export const ISDescription = styled.p`
  font-size: 1rem;
  font-weight: 700;
  color: ${({ theme }) => theme.forecast.text1};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 30ch;
`

export const ISInputDisplay = styled.p`
  font-size: 1rem;
  font-weight: 500;
  color: ${({ theme }) => theme.forecast.text1};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 30ch;
  cursor: pointer;
`

export const ISInputField = styled.input`
  font-size: 1rem;
  font-weight: 500;
  color: ${({ theme }) => theme.forecast.text1};
  background-color: ${({ theme }) => theme.forecast.background1};
  border: 1px solid ${({ theme }) => theme.forecast.border};
  border-radius: 4px;
  padding: 0.25rem 0.5rem;
  width: 100%;
  max-width: 30ch;

  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.forecast.border};
  }
`

export const ISEditButton = styled.button`
  background: none;
  border: none;
  padding: 0;
  margin-left: 0.5rem;
  cursor: pointer;
  color: inherit;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  & > svg {
    flex-shrink: 0;
    width: 1rem;
    height: 1rem;
  }
`

export const ISAssetVizContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 50%;
  height: 100%;
  background-color: #262626;
  padding: 1rem;
  box-sizing: border-box;
  gap: 1rem;
`

export const ISAssetVizInputSelectRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100%;
`

export const ISStyledSelectDiv = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1rem;
  width: 100%;
`

export const ISStyledSelectLabel = styled.p`
  font-size: 1rem;
  font-weight: 700;
  color: ${({ theme }) => theme.forecast.text1};
`

export const ISButtonsRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
`

export const ISButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1rem;
`

export const ISVizContainer = styled.div`
  padding: 1rem;
`

export const ISIconButtonsRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
  padding: 0.5rem;
  justify-content: flex-end;
`

export const ISNoInspectionMessage = styled.div`
  color: ${({ theme }) => theme.forecast.textDisabled};
  padding: 2rem;
  text-align: center;
  font-size: 1rem;
  font-weight: 500;
`

export const ISSpacer = styled.div`
  flex: 1;
`

export const ISEditSaveCancelButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1rem;
  justify-content: flex-end;
  width: 100%;
`
